import { Component, Input } from "@angular/core";

@Component({
    selector: "notification-bubble",
    imports: [],
    templateUrl: "./notification-bubble.component.html"
})
export class NotificationBubbleComponent {
    @Input() public display!: boolean;

    public constructor() {

    }
}